import { render, staticRenderFns } from "./DocumentGrid.vue?vue&type=template&id=72add1bd&scoped=true"
import script from "./DocumentGrid.vue?vue&type=script&lang=js"
export * from "./DocumentGrid.vue?vue&type=script&lang=js"
import style0 from "./DocumentGrid.vue?vue&type=style&index=0&id=72add1bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72add1bd",
  null
  
)

export default component.exports